import React from 'react';
import { Table, Panel, Label, Button } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { mapStatusToLabel } from './utils';
import ui from '../../common/services/ui';
import LabelWithTooltip from '../../common/components/LabelWithTooltip';
import { ConfirmationButton } from '../../common/components/formControls';
import { faRepeat, faRefresh, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const InstalmentList = ({ instalments, instalmentTemplateName, instalmentPlan, isInactive, canRetryInstalment, retryInstalment, paymentMethod, onRefresh,
	markInstalmentAsPaid, canMarkInstalmentAsPaid, t }) => {
	let instalmenNumber = 0;
	const showInstalmentPlan = instalmentPlan && instalmentPlan.totalIntervals > 0;
	let instalmentPlanText = showInstalmentPlan > 0 ? (instalmentPlan.hasDeposit ? t('InstalmentPlan_WithDeposit', { count: instalmentPlan.totalIntervals }) : t('InstalmentPlan_WithoutDeposit', { count: instalmentPlan.totalIntervals })) :
		t('PaymentHistory_Instalments');
	return <Panel>
		<Panel.Heading>
			<span>{instalmentPlanText}</span>
			<div className='panel-tools' key='panel-tools'>
				<Button bsStyle='link' onClick={onRefresh}>
					<LabelWithTooltip tooltip={t('PaymentHistory_Refresh')} placement='left'><FontAwesomeIcon icon={faRefresh} /></LabelWithTooltip>
				</Button>
			</div>
		</Panel.Heading>
		<Panel.Body>
			<Table responsive>
				<thead>
					<tr>
						<th>{t('InstalmentPayment_Id')}</th>
						<th>{t('InstalmentPayment_ChargeDate')}</th>
						<th>{t('InstalmentPayment_Amount')}</th>
						<th>{t('InstalmentPayment_Type')}</th>
						<th>{t('PaymentHistory_Status')}</th>
						<th>{t('PaymentHistory_PaymentDate')}</th>
						<th>{t('InstalmentPayment_Transaction')}</th>
						<th>{t('PaymentHistory_Created')}</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					{instalments && instalments.map((instalment, index) => {
						instalmenNumber = instalmenNumber + (instalment.type.id === 1 ? 0 : 1);
						const statusLabel = <Label bsStyle={mapStatusToLabel(instalment.status.id)}>{t(`InstalmentPaymentStatusType_${instalment.status.name}`)}</Label>;
						const nextRetry = instalment.nextRetryDate ? t('InstalmentPayment_NextRetry', { nextRetryDate: ui.formatDateTime(instalment.nextRetryDate) }): '';
						const statusContent = instalment.status.id === 3 ? <span><LabelWithTooltip tooltip={`${instalment.cancellationReason} ${nextRetry}`}>{statusLabel}</LabelWithTooltip>{!isInactive && instalment.nextRetryDate && <Label bsStyle='danger' className='ml-05'>{t('InstalmentPayment_Retrying')}</Label>}</span> : statusLabel;
						const type = t(`InstalmentPaymentType_${instalment.type.name}`) + (showInstalmentPlan ? (instalment.type.id === 1 ? '' :
							` ${t('InstalmentPayment_InstalmentNumber', { number: instalmenNumber, totalIntervals: instalmentPlan.totalIntervals })}`) : '');

						return <tr key={index}>
							<td>{instalment.id}</td>
							<td>{ui.formatDate(instalment.chargeDate)}</td>
							<td>{instalment.amount.toFixed(2)}</td>
							<td>{type}</td>
							<td>{statusContent}</td>
							<td>{ui.formatDateTime(instalment.paymentDate)}</td>
							<td>{instalment.transaction}</td>
							<td>{ui.formatDateTime(instalment.created)}</td>
							<td>
								{instalment.canRetry && canRetryInstalment && <ConfirmationButton bsStyle='warning' icon={faRepeat} displayType='inline-block' style={{ marginBottom: '5px', marginRight: '5px' }}
									onConfirmation={() => retryInstalment(instalment.id)}
									confirmationTitle={t('PaymentHistory_RetryInstalmentConfirmationTitle')}
									confirmationMessage={t(`FO_PaymentMethod_${paymentMethod.name}_RetryInstalmentConfirmationMessage`, { amount: instalment.formatedAmount })}
									label={t('PaymentHistory_RetryInstalment')} />}
								{instalment.canMarkAsPaid && canMarkInstalmentAsPaid && <Button onClick={() => markInstalmentAsPaid(instalment)} bsStyle='primary' style={{ marginRight: '5px' }}><FontAwesomeIcon icon={faCheck} /> {t('PaymentHistory_MarkAsPaid')}</Button>}
							</td>
						</tr>;
					})
					}
				</tbody>
			</Table>
		</Panel.Body>
	</Panel>
}

export default withTranslation()(InstalmentList);